import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.baseURL = process.env.VUE_APP_API_URL
// axios.defaults.baseURL = process.env.VUE_APP_API_URL !== 'MRC'
//   ? window.location.origin
//   : process.env.VUE_APP_API_URL
